export default __webpack_public_path__ + "static/media/event.2580afd3.jpg";